// import _get from 'lodash.get';
// import produce from 'immer';
import { getFeedUrl } from 'helpers/feeds/generalHelpers';

import reducerRegistry from '../../reduxUtils/reducerRegistry';
import makeRequest from '../../utils/makeRequest';
import {
  // TOI_PLUS_HOMEPAGE_CARDCMS_LITE_URL,
  CROSSWORD_JSON_URL,
} from '../../constants/index';

const reducerName = 'toiplushome';
const createActionName = name => `toi/${reducerName}/${name}`;

// Actions

export const RECEIVE_INITIAL_HOME_DATA = createActionName(
  'RECEIVE_INITIAL_HOME_DATA',
);
// Card-Inserts Action
export const RECEIVE_CARDS_INSERT_LITE_DATA = createActionName(
  'RECEIVE_CARDS_INSERT_LITE_DATA',
);
export const HANDLE_CARDS_INSERTS_DATA_LITE_ERROR = createActionName(
  'HANDLE_CARDS_INSERTS_DATA_LITE_ERROR',
);
export const RECEIEVE_CROSSWORD_DATA = createActionName(
  'RECEIVE_CROSSWORD_DATA',
);
// Card-Inserts Action & payload

function receiveCrosswordData(data) {
  return {
    type: RECEIEVE_CROSSWORD_DATA,
    payload: data,
  };
}
// function receiveCardInsertLiteData(data) {
//   return {
//     type: RECEIVE_CARDS_INSERT_LITE_DATA,
//     payload: data,
//   };
// }

// Card-Inserts Action & payload in error case
// function handleCardInsertLiteDataError() {
//   return {
//     type: HANDLE_CARDS_INSERTS_DATA_LITE_ERROR,
//     payload: {},
//   };
// }
export const HANDLE_DATA_ERROR = createActionName('HANDLE_DATA_ERROR');
export const HANDLE_CROSSWORDDATA_ERROR = createActionName(
  'HANDLE_CROSSWORDDATA_ERROR',
);

// Action Creators

function receiveHomeData(data) {
  return {
    type: RECEIVE_INITIAL_HOME_DATA,
    payload: {
      ...data,
    },
  };
}

function handleHomeDataError(error) {
  return {
    type: HANDLE_DATA_ERROR,
    error,
  };
}
function handleCrosswordDataError() {
  return {
    type: HANDLE_CROSSWORDDATA_ERROR,
    payload: {},
  };
}

// function fetchCardsInsertLite() {
//   return makeRequest.get(TOI_PLUS_HOMEPAGE_CARDCMS_LITE_URL, 'skipfeedengine');
// }

// Data Gatherers

function fetchHomeData(params) {
  const isWapView = !!params.isWapView;
  const url = `${getFeedUrl()}/toi/web/show/toiphome?version=v2&path=/toi-plus/toiphome/&rls=true`;
  return makeRequest.get(url, { isMobile: isWapView });
}
function fetchCrosswordData() {
  const url = CROSSWORD_JSON_URL;
  return makeRequest.get(url);
}

// Exposed Functions
export function loadCrosswordData(params) {
  return dispatch =>
    fetchCrosswordData(params)
      .then(data => dispatch(receiveCrosswordData(data.data)))
      .catch(error => dispatch(handleCrosswordDataError(error)));
}

export function loadHomeData(params) {
  return dispatch =>
    fetchHomeData(params)
      .then(data => dispatch(receiveHomeData(data.data, params)))
      .catch(error => dispatch(handleHomeDataError(error)));
}

// export function loadCardInsertLiteData() {
//   return dispatch =>
//     fetchCardsInsertLite()
//       .then(response => {
//         dispatch(receiveCardInsertLiteData(response.data));
//       })
//       .catch(error => {
//         dispatch(handleCardInsertLiteDataError(error));
//       });
// }

// Reducer

export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case RECEIVE_INITIAL_HOME_DATA: {
      return {
        ...state,
        ...action.payload,
      };
    }

    case RECEIVE_CARDS_INSERT_LITE_DATA: {
      return {
        ...state,
        cardsInsertsLite: action.payload,
      };
    }
    case RECEIEVE_CROSSWORD_DATA: {
      return {
        ...state,
        crosswordData: action.payload,
      };
    }

    case HANDLE_CARDS_INSERTS_DATA_LITE_ERROR: {
      return {
        ...state,
        cardsInsertsLite: null,
      };
    }
    case HANDLE_CROSSWORDDATA_ERROR: {
      return {
        ...state,
        crosswordData: null,
      };
    }
    default:
      return state;
  }
}

reducerRegistry.register(reducerName, reducer);
